<template>
  <div class="box-card w-full responsiveTable-card" :class="{ 'mobile-view': isMobileScreen }">
    <el-tabs v-model="activeTab" class="team-tabs">
      <el-tab-pane v-if="isTerminalUser" label="Team" name="team">
        <company-team />
      </el-tab-pane>

      <el-tab-pane label="All User" name="all">
        <all-user ref="allUserRef" :page-num="pageNum" :page-size="pageSize" @update-total="total = $event" />
      </el-tab-pane>
    </el-tabs>

    <div v-if="activeTab === 'all'" class="fixed-pagination">
      <el-pagination background layout="prev, pager, next, total" :current-page="pageNum" :page-size="pageSize"
        :total="total" @current-change="handlePageChange" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CompanyTeam from "@/components/company/company-team.vue";
import AllUser from "@/components/company/jput-view.vue";

export default {
  name: "company-team-management",

  components: {
    CompanyTeam,
    AllUser,
  },

  data() {
    return {
      activeTab: "all",
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },

  methods: {
    handlePageChange(page) {
      this.pageNum = page;

      this.$nextTick(() => {
        this.$refs.allUserRef?.getList?.();
      });
    },
  },

  computed: {
    ...mapState(["screenType", "userInfo"]),

    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    isTerminalUser() {
      this.activeTab = this.$store.state.userInfo?.userType == 1 || this.$store.state.userInfo?.userType == 0 ? "team": "all"
      return this.$store.state.userInfo?.userType == 1 || this.$store.state.userInfo?.userType == 0;
    },
  },
};
</script>

<style scoped lang="scss">
.responsiveTable-card {
  position: absolute;
  width: 100%;
  height: calc(82vh - 10px);
  background: #ffffff;
  border-radius: 10px;
  padding: 14px 16px 16px;
  box-sizing: border-box;
}

.team-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs__header {
  margin: 0 0 14px;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

::v-deep .el-tabs__nav {
  display: flex;
  gap: 8px;
  padding: 4px;
  background: #f5f7fa;
  border-radius: 10px;
}

::v-deep .el-tabs__active-bar {
  display: none;
}

::v-deep .el-tabs__item {
  height: 34px;
  line-height: 34px;
  padding: 0 18px !important;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #82889c;
  transition: all 0.2s ease;
}

::v-deep .el-tabs__item:hover {
  color: #008cdb;
  background: #ffffff;
}

::v-deep .el-tabs__item.is-active {
  color: #008cdb;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 140, 219, 0.12);
}

::v-deep .el-tab-pane {
  height: 100%;
}

.mobile-view {
  padding: 8px;

  ::v-deep .el-tabs__nav {
    width: 100%;
  }

  ::v-deep .el-tabs__item {
    flex: 1;
    text-align: center;
    font-size: 12px;
    padding: 0 10px !important;
  }
}

::v-deep .el-tabs__content {
  flex: 1;
  height: calc(100% - 80px);
  overflow: hidden;
  border: 1px solid #edf0f5;
  border-radius: 10px;
  background: #ffffff;
}

.fixed-pagination {
  height: 48px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 4px 0;
  background: #ffffff;
}
</style>